import { render, staticRenderFns } from "./FillTopic.vue?vue&type=template&id=f24327aa&scoped=true"
import script from "./FillTopic.vue?vue&type=script&lang=js"
export * from "./FillTopic.vue?vue&type=script&lang=js"
import style0 from "./FillTopic.vue?vue&type=style&index=0&id=f24327aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24327aa",
  null
  
)

export default component.exports